import { defaultClient } from '@mint-sdk/api-core';

import { MetadataResponseSchema } from '../shared/schemas/metadata.js';

export const getMetadataQueryOptions = defaultClient.query({
  url: 'planning-service/media-plans/$mediaPlanId/metadata/' as const,
  method: 'GET',
  responseSchema: MetadataResponseSchema,
  processResponse(data) {
    return data.data?.items[0];
  },
});
